import { combineReducers } from 'redux';

import { IAction, IState } from 'shared/interface/state';

import login, { initialState } from 'features/auth/login/store/login.reducer';
import notificationReducer, { notificationInitialState } from 'hoc/layout/store/notification.reducer';
import commonReducer, { commonInitialState } from './common.reducer';

const appReducer = combineReducers({
	auth: login,
	notification: notificationReducer,
	common: commonReducer
});

const rootReducer = (state: IState | undefined, action: IAction) => {
	return appReducer(state, action);
};

export default rootReducer;

export const initialStore: RootState = {
	auth: initialState,
	notification: notificationInitialState,
	common: commonInitialState
};
export type RootState = ReturnType<typeof appReducer> | undefined;
